const DefaultComponent = () => import('@/ui-overrides/default/pages/request/create/pois.vue');


export default {
	name: 'PoisWrapper',

	functional: true,

	render(h, context) {
		let component = DefaultComponent;

		const uiOverride = context.parent.$store.state.agency.default_ui;

		try {
			const override = require(`@/ui-overrides/${uiOverride}/pages/request/create/pois.vue`);
			component = override.default;
		}
		catch (err) {
			context.parent.$log.debug(`No override found: ${err}`);
		}

		return h(
			component,
			context.data,
			context.children,
		);
	},
};
